module.exports = __webpack_public_path__ + "static/16-4f547262897cb5d5699abfb7e2cc5fd8.jpg";